import { StyleSheet } from 'react-native'
import { AppTheme } from '../../theme';

export const dashboardStyles = (theme: AppTheme) => StyleSheet.create({
    mainContainer: {
        backgroundColor: theme?.lightBackgroundColor,
        flex: 1
    },
    headerRight: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    notificationIcon: {
        paddingHorizontal: 5
    },
    scrollContent: {
        flexGrow: 1,
        paddingBottom: 20
    },
    welcomeBanner: {
        paddingHorizontal: 10,
        paddingVertical: 15,
        backgroundColor: theme?.light,
        marginHorizontal: 10,
        marginTop: 10,
        borderRadius: 5
    },
    loaderStyle: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme?.lightBackgroundColor
    },
    rowContainer: {
        marginHorizontal: 10,
        marginVertical: 10,
        justifyContent: 'space-between',
    },
    statCard: {
        backgroundColor: theme?.light,
        paddingHorizontal: 5,
        paddingVertical: 10,
        borderRadius: 7,
        elevation: 2,
    },
    statCardHorizontal: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center'
    },
    statCardVertical: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    statIconImage: {
        width: 50,
        height: 50
    },
    statContent: {
        marginLeft: 10
    },
    statTitle: {
        fontSize: theme?.smallFontSize,
        paddingTop: 2,
        textAlign: "center"
    },
    statValue: {
        fontSize: theme?.mediumFontSize,
        paddingVertical: 5,
        textAlign: "center"
    },
    statSubtitle: {
        fontSize: theme.mediumFontSize,
        textAlign: "center"
    },
    revenueContainer: {
        backgroundColor: theme.light,
        borderRadius: 7,
        justifyContent: 'center',
        alignItems: 'center',
        elevation: 2,
    },
    revenueContent: {
        paddingHorizontal: 8,
        paddingVertical: 10,
    },
    revenueHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%'
    },
    revenueTitleText: {
        color: theme.primary,
        fontSize: theme.smallFontSize,
        paddingTop: 2
    },
    tooltipPopover: {
        elevation: 10,
        paddingHorizontal: 5,
    },
    filterPopoverContainer: {
        width: "100%",
        marginVertical: 5
    },
    filterItem: {
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: 4,
        paddingHorizontal: 5,
    },
    checkIcon: {
        paddingHorizontal: 3
    },
    popoverTriggerInfo: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    pieChartContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: -35
    }, // handled dynamic margin in component, base here? No, let's keep dynamic inline or handle it.
    pieCenterLabel: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    noDataContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        gap: 10
    },
    noDataText: {
        textAlign: "center"
    },
    legendContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        bottom: 35,
    },
    legendItem: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '35%',
        marginVertical: 3,
    },
    dot: {
        height: 10,
        width: 10,
        borderRadius: 5,
        marginRight: 10,
    },
    offersRow: {
        marginHorizontal: 10,
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
    giftCardContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 15
    },
    progressSection: {
        width: '100%',
        marginTop: 20
    },
    stepIndicatorIcon: {
        alignSelf: "center"
    },
    stepIndicatorActive: {
        borderRadius: 20
    },

    // Existing styles from dashboardScreen.tsx
    cardContainer: {
        marginTop: 25,
        backgroundColor: theme.light, // Explicit White
        width: "80%",
        height: 100,
        padding: 10,
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 0.5,
        borderColor: '#eee',
        paddingHorizontal: 10
    },
    activeCard: {
        borderColor: theme.green,
        borderWidth: 1,
        elevation: 8,
    },
    stepTitle: {
        color: theme.primary,
        textAlign: "center"
    },
    stepReaction: {
        textTransform: 'capitalize',
        marginTop: 5
    },

    // Modal Styles
    modalContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.transparentBackground,
    },
    modalContent: {
        backgroundColor: theme.light,
        // width handled dynamically in component
        maxHeight: "60%",
        borderRadius: 10,
        padding: 15,
    },
    closeIcon: {
        alignSelf: "flex-end"
    },
    transparentLoader: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.transparentBackground
    }
});
